import React from "react";

function AccountCreatedConfirmation() {
  return (
    <div className="container p-5">
      <h1>Account Created!</h1>
      <p>Please check your email for an activation link</p>
    </div>
  );
}

export default AccountCreatedConfirmation;
